var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrediction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18887_34317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2891 15.7344L21.1475 20.609",
    stroke: "#595959",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 17.2809C15.1793 17.2809 18.3192 14.0945 18.3192 10.1639C18.3192 6.23326 15.1793 3.04688 11.3061 3.04688C7.43284 3.04688 4.29297 6.23326 4.29297 10.1639C4.29297 14.0945 7.43284 17.2809 11.3061 17.2809Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89586 17.2933C3.65383 17.2933 4.26829 16.6698 4.26829 15.9006C4.26829 15.1314 3.65383 14.5078 2.89586 14.5078C2.13789 14.5078 1.52344 15.1314 1.52344 15.9006C1.52344 16.6698 2.13789 17.2933 2.89586 17.2933Z",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00133 9.87927C9.7593 9.87927 10.3738 9.25571 10.3738 8.48651C10.3738 7.71731 9.7593 7.09375 9.00133 7.09375C8.24336 7.09375 7.62891 7.71731 7.62891 8.48651C7.62891 9.25571 8.24336 9.87927 9.00133 9.87927Z",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7904 13.2777C14.5484 13.2777 15.1628 12.6541 15.1628 11.8849C15.1628 11.1157 14.5484 10.4922 13.7904 10.4922C13.0324 10.4922 12.418 11.1157 12.418 11.8849C12.418 12.6541 13.0324 13.2777 13.7904 13.2777Z",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1068 6.67614C21.8648 6.67614 22.4792 6.05258 22.4792 5.28338C22.4792 4.51418 21.8648 3.89062 21.1068 3.89062C20.3488 3.89062 19.7344 4.51418 19.7344 5.28338C19.7344 6.05258 20.3488 6.67614 21.1068 6.67614Z",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05319 9.78906L3.83984 14.7751",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1055 9.32812L12.4974 11.23",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 11.163L20.0892 6.53906",
    stroke: "#595959",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18887_34317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrediction);
export default __webpack_public_path__ + "static/media/Prediction.67902be581dd3772c66073e78acca1a6.svg";
export { ForwardRef as ReactComponent };